
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace('')
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as _91_46_46_46slug_93kMFXMiTZiOMeta } from "/tmp/menaceking-build-1751976185/pages/[...slug].vue?macro=true";
import { default as autologinluwdb4mRmXMeta } from "/tmp/menaceking-build-1751976185/pages/auth/autologin.vue?macro=true";
import { default as callback94AI2fbqYmMeta } from "/tmp/menaceking-build-1751976185/pages/auth/social/[connection]/callback.vue?macro=true";
import { default as bettingoSFM11IrK9Meta } from "/tmp/menaceking-build-1751976185/pages/betting.vue?macro=true";
import { default as _91pageIdentity_93n8hzDy9OWfMeta } from "/tmp/menaceking-build-1751976185/pages/bonus/[pageIdentity].vue?macro=true";
import { default as _91categoryIdentity_93U5BogNTc5NMeta } from "/tmp/menaceking-build-1751976185/pages/categories/[categoryIdentity].vue?macro=true";
import { default as categories2JH30qJCfFMeta } from "/tmp/menaceking-build-1751976185/pages/categories.vue?macro=true";
import { default as contacthotKCE79mZMeta } from "/tmp/menaceking-build-1751976185/pages/contact.vue?macro=true";
import { default as favorites_46clientbgOd1jAer5Meta } from "/tmp/menaceking-build-1751976185/pages/favorites.client.vue?macro=true";

let _createClientPage
async function createClientPage(loader) {
  _createClientPage ||= await import("/tmp/menaceking-build-1751976185/node_modules/nuxt/dist/components/runtime/client-component.js").then(r => r.createClientPage)
  return _createClientPage(loader);
}
import { default as _91id_93nOl6mOuRrKMeta } from "/tmp/menaceking-build-1751976185/pages/games/[id].vue?macro=true";
import { default as indexaNVLnVKjaMMeta } from "/tmp/menaceking-build-1751976185/pages/index.vue?macro=true";
import { default as loyalty0rgqR3xstrMeta } from "/tmp/menaceking-build-1751976185/pages/loyalty.vue?macro=true";
import { default as main383gsH4qmiMeta } from "/tmp/menaceking-build-1751976185/pages/main.vue?macro=true";
import { default as bonusesTJxVg7f1lJMeta } from "/tmp/menaceking-build-1751976185/pages/profile/bonuses.vue?macro=true";
import { default as documents2vA8diBSfJMeta } from "/tmp/menaceking-build-1751976185/pages/profile/documents.vue?macro=true";
import { default as historyvPgaCVahXkMeta } from "/tmp/menaceking-build-1751976185/pages/profile/history.vue?macro=true";
import { default as infoxOWudxwzpwMeta } from "/tmp/menaceking-build-1751976185/pages/profile/info.vue?macro=true";
import { default as limits0f9MU3kD6zMeta } from "/tmp/menaceking-build-1751976185/pages/profile/limits.vue?macro=true";
import { default as notificationsnnLDC6WPj6Meta } from "/tmp/menaceking-build-1751976185/pages/profile/notifications.vue?macro=true";
import { default as securityZK1DEUtsyvMeta } from "/tmp/menaceking-build-1751976185/pages/profile/security.vue?macro=true";
import { default as verificationCujcXnbRzqMeta } from "/tmp/menaceking-build-1751976185/pages/profile/verification.vue?macro=true";
import { default as walletrpwczlcRCZMeta } from "/tmp/menaceking-build-1751976185/pages/profile/wallet.vue?macro=true";
import { default as profile_46clientXeVKWDTlGPMeta } from "/tmp/menaceking-build-1751976185/pages/profile.client.vue?macro=true";
import { default as providerslyUkgdNyhWMeta } from "/tmp/menaceking-build-1751976185/pages/providers.vue?macro=true";
import { default as _91pageIdentity_93kucTCd6ei5Meta } from "/tmp/menaceking-build-1751976185/pages/questions/[pageIdentity].vue?macro=true";
import { default as questionsa4GxlblsPbMeta } from "/tmp/menaceking-build-1751976185/pages/questions.vue?macro=true";
import { default as recently_45played_46clientui3tRMcI68Meta } from "/tmp/menaceking-build-1751976185/pages/recently-played.client.vue?macro=true";
import { default as _91pageIdentity_930Qyz7MOZSSMeta } from "/tmp/menaceking-build-1751976185/pages/static/[pageIdentity].vue?macro=true";
import { default as _91identity_93u4q1rVWldvMeta } from "/tmp/menaceking-build-1751976185/pages/tournaments/[identity].vue?macro=true";
import { default as indexzONok81GLOMeta } from "/tmp/menaceking-build-1751976185/pages/tournaments/index.vue?macro=true";
import { default as welcome_45packageLTqdqlqewmMeta } from "/tmp/menaceking-build-1751976185/pages/welcome-package.vue?macro=true";
export default [
  {
    name: "slug",
    path: "/:slug(.*)*",
    component: () => import("/tmp/menaceking-build-1751976185/pages/[...slug].vue")
  },
  {
    name: "auth-autologin",
    path: "/auth/autologin",
    component: () => import("/tmp/menaceking-build-1751976185/pages/auth/autologin.vue")
  },
  {
    name: "auth-social-connection-callback",
    path: "/auth/social/:connection()/callback",
    component: () => import("/tmp/menaceking-build-1751976185/pages/auth/social/[connection]/callback.vue")
  },
  {
    name: "betting",
    path: "/betting",
    component: () => import("/tmp/menaceking-build-1751976185/pages/betting.vue")
  },
  {
    name: "bonus-pageIdentity",
    path: "/bonus/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1751976185/pages/bonus/[pageIdentity].vue")
  },
  {
    name: "categories",
    path: "/categories",
    meta: categories2JH30qJCfFMeta || {},
    component: () => import("/tmp/menaceking-build-1751976185/pages/categories.vue"),
    children: [
  {
    name: "categories-categoryIdentity",
    path: ":categoryIdentity()",
    component: () => import("/tmp/menaceking-build-1751976185/pages/categories/[categoryIdentity].vue")
  }
]
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/tmp/menaceking-build-1751976185/pages/contact.vue")
  },
  {
    name: "favorites",
    path: "/favorites",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1751976185/pages/favorites.client.vue"))
  },
  {
    name: "games-id",
    path: "/games/:id()",
    component: () => import("/tmp/menaceking-build-1751976185/pages/games/[id].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/tmp/menaceking-build-1751976185/pages/index.vue")
  },
  {
    name: "loyalty",
    path: "/loyalty",
    component: () => import("/tmp/menaceking-build-1751976185/pages/loyalty.vue")
  },
  {
    name: "main",
    path: "/main",
    component: () => import("/tmp/menaceking-build-1751976185/pages/main.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1751976185/pages/profile.client.vue")),
    children: [
  {
    name: "profile-bonuses",
    path: "bonuses",
    component: () => import("/tmp/menaceking-build-1751976185/pages/profile/bonuses.vue")
  },
  {
    name: "profile-documents",
    path: "documents",
    component: () => import("/tmp/menaceking-build-1751976185/pages/profile/documents.vue")
  },
  {
    name: "profile-history",
    path: "history",
    component: () => import("/tmp/menaceking-build-1751976185/pages/profile/history.vue")
  },
  {
    name: "profile-info",
    path: "info",
    component: () => import("/tmp/menaceking-build-1751976185/pages/profile/info.vue")
  },
  {
    name: "profile-limits",
    path: "limits",
    component: () => import("/tmp/menaceking-build-1751976185/pages/profile/limits.vue")
  },
  {
    name: "profile-notifications",
    path: "notifications",
    component: () => import("/tmp/menaceking-build-1751976185/pages/profile/notifications.vue")
  },
  {
    name: "profile-security",
    path: "security",
    component: () => import("/tmp/menaceking-build-1751976185/pages/profile/security.vue")
  },
  {
    name: "profile-verification",
    path: "verification",
    component: () => import("/tmp/menaceking-build-1751976185/pages/profile/verification.vue")
  },
  {
    name: "profile-wallet",
    path: "wallet",
    component: () => import("/tmp/menaceking-build-1751976185/pages/profile/wallet.vue")
  }
]
  },
  {
    name: "providers",
    path: "/providers",
    component: () => import("/tmp/menaceking-build-1751976185/pages/providers.vue")
  },
  {
    name: "questions",
    path: "/questions",
    meta: questionsa4GxlblsPbMeta || {},
    component: () => import("/tmp/menaceking-build-1751976185/pages/questions.vue"),
    children: [
  {
    name: "questions-pageIdentity",
    path: ":pageIdentity()",
    component: () => import("/tmp/menaceking-build-1751976185/pages/questions/[pageIdentity].vue")
  }
]
  },
  {
    name: "recently-played",
    path: "/recently-played",
    component: () => createClientPage(() => import("/tmp/menaceking-build-1751976185/pages/recently-played.client.vue"))
  },
  {
    name: "static-pageIdentity",
    path: "/static/:pageIdentity()",
    component: () => import("/tmp/menaceking-build-1751976185/pages/static/[pageIdentity].vue")
  },
  {
    name: "tournaments-identity",
    path: "/tournaments/:identity()",
    component: () => import("/tmp/menaceking-build-1751976185/pages/tournaments/[identity].vue")
  },
  {
    name: "tournaments",
    path: "/tournaments",
    component: () => import("/tmp/menaceking-build-1751976185/pages/tournaments/index.vue")
  },
  {
    name: "welcome-package",
    path: "/welcome-package",
    component: () => import("/tmp/menaceking-build-1751976185/pages/welcome-package.vue")
  }
]